<template lang="html">
    <div class="application">
        <h2>{{getTextArray('motor_nav')[1][getLangage]}}</h2>
        <div class="select-application">
            <el-form-item prop="application_type" style="margin-bottom: 30px;" class="formSelect" :show-message="showMessage('application_type')">
                <el-row :gutter="50" type="flex" justify="space-between">
                    <el-col
                        v-for="type in $store.state.applications"
                        :key="type"
                        :xs="12"
                        :sm="8"
                        :md="6"
                        align="center"
                        class="card"
                    >

                        <el-card class="card-1-cta content">
                            <div slot="header" class="card-title-container" :class="{'selected': isSelectedType(type)}" @click="setApplicationType(type)">
                                <p class="cardTitle">{{getTranslation(type)}}</p>
                            </div>
                            <div
                                @click="setApplicationType(type)"
                                class="image-container"
                                :style="{backgroundImage: getImageSrc(type)}"
                            >
                                <!-- <img :src="getImageSrc(type)" alt="image"> -->
                            </div>
                        </el-card>

                    </el-col>
                </el-row>

            </el-form-item>

        </div>
    </div>
</template>

<script>

import {mapGetters} from 'vuex';

export default {
    data() {
        return {
            msg: '',
            factory: {},
        };
    },
    computed: {
        ...mapGetters([
            'getText',
            'getTextArray',
            'getLangage'
        ])
    },
    props: {
        factoryEngine: {
            type: Object,
            required: true
        },
    },
    methods: {
        getButtonContent(type) {
            return (this.factoryEngine.application_type == type) ? this.getText('selected_button') : this.getText('select_button');
        },
        showMessage(el) {
            if (this.factoryEngine[el].length)
                return true;
            return false;
        },
        setApplicationType(typeuid) {
            this.factoryEngine.application_type === typeuid ? this.factoryEngine.application_type = '' : this.factoryEngine.application_type = typeuid;
        },
        isSelectedType(typeuid) {
            return (this.factoryEngine.application_type == typeuid) ? true : false;
        },
        getTranslation(type) {
            return this.$store.state.trad[type][this.getLangage];
        },
        getImageSrc(type) {
            return `url("/static/img/${this.$store.state.img[type]}")`;
        }
    }
};
</script>

<style lang="less">
@import '../../../less/variables';

// .regulation-type-desc {
//     img {
//         margin-bottom: 20px !important;
//     }
//     margin-bottom: 20px !important;
//     font-size: 16px !important;
// }
.application {
    border: 5px solid #efefef !important;
    padding: 5px 0;
    .select-application {
        @media @desktop {
            width: 80%;
            margin: auto;
            margin-top: 40px;
        }
    }
    .el-row {
        margin: 0 !important;
        flex-wrap: wrap;
    }
    .card {
        height: 200px;
        margin-bottom: 20px;
        .el-card__header {
            padding: 0;
            position: relative;
            z-index: 1;
        }
        .cardTitle {
            text-transform: uppercase;
            font-size: 16px;
            font-weight: 600;
            line-height: 24px;
            padding: 10px 0;
            margin: 0;
            color: @color-1;
        }
        .el-card__body {
            // position: relative;
            padding: 0;
            height: calc(100% - 45px);

            .image-container {
                cursor: pointer;
                height: 100%;
                background-size: contain;
                background-repeat: no-repeat;
                background-position: center;
            }
        }
    }
}

.selected {
    background-color: @color-1 !important;
    color: white !important;
    .cardTitle {
        color: white !important;
    }
}
// .none {
//     width: auto;
//     height: 80px !important;
// }

.applicationButton {
    margin-top: 20px;
    font-size: 15px;
    border: none;
    text-transform: uppercase;
    font-family: worksans, Arial, "Helvetica Neue", Helvetica, sans-serif;
    line-height: 18px;
    box-shadow: rgba(0, 0, 0, 0.2) 0px 1px 5px 0px, rgba(0, 0, 0, 0.14) 0px 2px 2px 0px, rgba(0, 0, 0, 0.12) 0px 3px 1px -2px;
    padding: 15px 30px 10px;
    background: @color-1;
    color: white;
}

.applicationButton:hover, .applicationButton:focus {
    background: @color-1;
    color: white;
}


</style>



// WEBPACK FOOTER //
// src/components/partials/wizzard/ApplicationTypeForm.vue